<template>
    <div>
        <v-container grid-list-xs>
            <template>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-btn class="font-weight-light" tile color="black" dark  @click="btn_add"  >
                        <v-icon >add</v-icon>
                    </v-btn>
                </v-toolbar>
            </template>
        </v-container>
            <v-dialog v-model="dialog_s" width="450" >
                <v-card>
                    <v-card-title class="headline">Select Product</v-card-title>
                        <v-container>    
                            <v-text-field
                                v-model="searchQuery"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                            <v-divider></v-divider>
                            <br>
                            <table width="100%">
                                <tr v-for="item in resultQuery" :key="item.code" @click="saveItem( item.code )"  >            
                                    <td width="20%"><h4 class="font-weight-light">{{item.code}}</h4></td>
                                    <td width="80%"><h4 class="font-weight-light">{{item.name}}</h4></td> 
                                </tr>
                            </table>                                
                        </v-container>
                </v-card>
            </v-dialog>
        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.code }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.descrip }}</td>
                <td class="text-xs-left">{{ props.item.price }}</td>
                <td class="text-xs-left">{{ props.item.category }}</td>
                <td class="text-xs-center">{{ props.item.active }}</td>
                <td class="text-xs-left" ><img :src="url + props.item.image " class="image"  width="50px" height="50px"></td>
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="del_prod(props.item.code)">delete</v-icon>
                </td>

                </template>

            </v-data-table>

            
        </v-container>

    </div>
</template>

<script>
import axios from "axios"
export default {

data() {
    return {
            /** กำหนด headers ให้ตรง */
            headers:[ 
              { text: 'Code', value: 'code' },
              { text: 'Name', value: 'name' },
              { text: 'details', value: 'address' },
              { text: 'price', value: 'tel' },
              { text: 'category', value: 'location' },
              { text: 'active', value: 'active' },
              { text: 'image', value: 'image' },
              { text: 'Actions', value: 'actions', align: 'center', sortable: false },
            ],
            table_details:[],
            users: [],
            search: '',
            searchQuery : '',
            products :[],
            dialog_s: false,
            current_cust_code : '',
            current_cust_name : '',
            url : "https://ws.plantifulbkk.shop/images/" ,
        }
    },
    created () {
      console.log("CREATE")
      this.read_data()
      this.read_data_product()
    },
    computed:{
        resultQuery(){
            if(this.searchQuery){
            return this.products.filter((item)=>{
                return this.searchQuery.toLowerCase().split(' ').every(v => item.name.toLowerCase().includes(v))
            })
            }else{
                return this.products;
            }
        },
    },
    methods :{
        read_data() {
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_product_addon.php').then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.users = result
            console.log(vm.users)
            });
        },
        read_data_product() {
                const vm = this;
                
                vm.axios.get('https://ws.plantifulbkk.shop/get_product.php').then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.products = result
                console.log(vm.products)
            }); 
        },
        del_prod( code ){

            const vm = this;
            vm.axios.get("https://ws.plantifulbkk.shop/post_del_addon_menu.php",{
                params: {
                    scode: code ,
                }
            }).then(result=>{
                    console.log(result.data)
                    this.read_data()
                })
            .catch(function (error) {
                    alert("Error")
                    console.log(error)
                })

        },
        btn_add(){  
            this.dialog_s = true
        },
        saveItem( code ){

            const vm = this;
            vm.axios.get("https://ws.plantifulbkk.shop/post_add_addon_menu.php",{
                params: {
                    scode: code ,
                }
            }).then(result=>{
                    console.log(result.data)
                    this.read_data()
                })
            .catch(function (error) {
                    alert("Error")
                    console.log(error)
                })

            this.dialog_s = false

        },
    },
    

}


</script>

<style>
 
@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@200&display=swap');

H2 {
  font-family: 'Mitr', sans-serif;
}

</style>


// WEBPACK FOOTER //
// src/pages/addon_menu.vue